import { ALL_LNGS_NAMESPACES } from '@ingenico/util-i18n-config';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { DeviceAppVersionCard } from '../device-app-version-card/DeviceAppVersionCard.ctrl';
import {
  SystemPackageVersionNameField,
  SystemPackageVersionReleaseNotesField,
} from '../system-package-version-fields/SystemPackageVersionFields.ctrl';
import type { SystemPackageVersionDefinitionSectionProps } from './systemPackageVersionDefinitionSection.model';

export function SystemPackageVersionDefinitionSection({
  control,
}: SystemPackageVersionDefinitionSectionProps): ReactNode {
  const { t } = useTranslation(ALL_LNGS_NAMESPACES.APPLICATION);

  return (
    <DeviceAppVersionCard subtitle={t('subtitle.defineSection')} title={t('title.defineSection')}>
      <SystemPackageVersionNameField control={control} required />
      <SystemPackageVersionReleaseNotesField control={control} />
    </DeviceAppVersionCard>
  );
}
